import React from 'react';
import BusinessAccountLogo from '../../../images/icons/business_account_logo.svg';

function BusinessAccount() {
  return (
     <img src={BusinessAccountLogo} className="h-10 w-10" alt="business-account" />
  )
}

export default BusinessAccount;
